import React, { useEffect, useState } from 'react';

const GclidFinder = () => {
  // Check if there is a value in localStorage
  const existingGclidValue =
    typeof window !== 'undefined' ? JSON.parse(localStorage.getItem('gclid')) : null;
  const [gclidValue, setGclidValue] = useState(existingGclidValue ? existingGclidValue.value : '');

  useEffect(() => {
    // Function to update localStorage with the current URL parameter value
    const updateLocalStorage = () => {
      const urlParams = new URLSearchParams(document.location.search);
      const parameterValue = urlParams.get('gclid') || urlParams.get('gclid_field');

      const getExpiryRecord = (value: any) => {
        const expiryPeriod = 90 * 24 * 60 * 60 * 1000; // 90 day expiry in milliseconds
        const expiryDate = new Date().getTime() + expiryPeriod;
        return {
          value: value,
          expiryDate: expiryDate,
        };
      };

      if (parameterValue && parameterValue !== gclidValue) {
        // Store the parameter in localStorage if it doesn't exist
        const validateGclsrc = () => {
          const gclsrcParam = urlParams.get('gclsrc');
          return !gclsrcParam || gclsrcParam.indexOf('aw') !== -1;
        };

        if (validateGclsrc()) {
          const gclidRecord = getExpiryRecord(parameterValue);

          if (typeof window !== 'undefined') {
            localStorage.setItem('gclid', JSON.stringify(gclidRecord));
          }

          setGclidValue(gclidRecord.value);
        }
      }
    };

    // Call the updateLocalStorage function when the component mounts
    updateLocalStorage();

    // Listen for the onpopstate event to update localStorage when the URL changes
    window.addEventListener('popstate', updateLocalStorage);

    return () => {
      // Cleanup: Remove the event listener when the component unmounts
      window.removeEventListener('popstate', updateLocalStorage);
    };
  }, []);

  return gclidValue;
};

export default GclidFinder;
